<template>
	<van-popup v-model="innerVisible" position="bottom" :safe-area-inset-bottom="true" :style="{ height: '35%' }">
		<van-picker
			:title="$t('活动时长')"
			show-toolbar
			:columns="columns"
			:default-index="durationIndex"
			class="cus-picker"
			@confirm="onConfirm"
			@cancel="cancelPopup"
			:confirm-button-text="$t('确定')"
		/>
	</van-popup>
</template>

<script>
import { Picker, Popup } from 'vant';

export default {
	components: {
		'van-popup': Popup,
		'van-picker': Picker
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			columns: [],
			durationIndex: 0
		};
	},
	computed: {
		innerVisible: {
			get() {
				return this.visible;
			},
			set(val) {
				this.$emit('update:visible', val);
			}
		}
	},
	methods: {
		setColumns(openingDuration) {
			let arr = [30, 45, 60, 90, 120];
			if (openingDuration) {
				arr.push(openingDuration);
				const uniqueArr = Array.from(new Set(arr));
				uniqueArr.sort((a, b) => a - b);
				let index = uniqueArr.findIndex(item => item == openingDuration);
				let targetArr = uniqueArr.slice(0, index + 1);
				this.columns = targetArr.map(item => ({ text: `${item}${this.$t('分钟')}`, value: item }));
			} else {
				this.columns = [];
			}
		},
		setDefaultDuration(duration) {
			this.durationIndex = this.columns.findIndex(item => item.value == duration);
		},
		cancelPopup() {
			this.innerVisible = false;
		},
		onConfirm({ value }) {
			this.cancelPopup();
			this.$emit('confirm', { value });
		}
	}
};
</script>

<style lang="less" scoped>
.cus-picker {
	/deep/.van-picker__cancel {
		display: none;
	}
	/deep/.van-picker__title {
		padding-left: 0.14rem;
		color: #333;
		font-size: 0.15rem;
		font-weight: 500;
	}
	/deep/.van-picker__confirm {
		color: #3f5bd6;
	}
}
</style>
